export default __webpack_public_path__ + "static/media/ALLERGEN_SULPHITES.3a0df88f.png";